import React, { useEffect } from "react";
import LearnersCreating from "../../../../components/Insights/StoriesSnapShot/LearnersCreating";
import HowTheyLearning from "../../../../components/Insights/StoriesSnapShot/HowTheyLearning";
import HowTheyDoing from "../../../../components/Insights/StoriesSnapShot/HowTheyDoing";
import SchoolWork from "../../../../components/Insights/SchoolWork/SchoolWork";
import { useDashboardFeed } from "../../../../hooks/useSchoolFeed";
import { useMetrics } from "../../../../hooks/useMetrics";

function ClassRoomView({ dashboardData }: { dashboardData: any }) {
  const schoolHash = dashboardData?.schoolHash;
  const grade = dashboardData?.grade;
  const range = dashboardData?.range;

  const { data: feedData,loading:feedloading,fetchMoreFeed, refetch: dashboardFetch } = useDashboardFeed({
    feedScopeType: "grade",
    schoolHash: schoolHash,
    grade: grade,
    enabled: !!schoolHash && !!grade,
  });

  const {
    data: metricsData,
    loading: mLoading,
    refetch: matricsFetch,
  } = useMetrics({
    scope: "class",
    schoolHash: schoolHash,
    grade: grade,
    range: range,
    enabled: !!schoolHash && !!grade,
  });

  // useEffect(() => {
  //   if (schoolHash && grade) {
  //     dashboardFetch();
  //     matricsFetch();
  //   }
  // }, [schoolHash, grade, range]);

  console.log(feedData, "feedDatafeedDatafeedDatafeedData");

  return (
    <>
      <LearnersCreating loading={mLoading} classroomData={metricsData} />
      <HowTheyDoing loading={mLoading} isClassroom={true} data={metricsData} />
      {/* <HowTheyLearning
        loading={mLoading}
        isSchool={true}
        learningData={metricsData}
      /> */}
      <SchoolWork title="This Class's Work" loading={feedloading} fetchMoreFeed={fetchMoreFeed} feedData={feedData} showGrade />
    </>
  );
}

export default ClassRoomView;
